import React from "react";

function SocialMedia({ socialMediaItems = [], socialMediaIcons = [] }) {
  return (
    <div className="social-media">
      {socialMediaItems.map((socialMedia, index) => (
        <div key={index} className="social-media__item">
          <a href={socialMedia.link} target="_blank">
            <img
              src={socialMediaIcons[index]}
              alt=""
              className="social-media__icon"
            />
          </a>
        </div>
      ))}
    </div>
  );
}

export default SocialMedia;
